import { render, staticRenderFns } from "./note-sidebar.vue?vue&type=template&id=4e1c1c30"
import script from "./note-sidebar.vue?vue&type=script&lang=js"
export * from "./note-sidebar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports